import axios from 'axios';

const CACHE_KEY = 'coingecko_rates';
const CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes

// localStorage is only available in browser environments (not in Node.js cron jobs).
const storage = typeof localStorage !== 'undefined' ? localStorage : null;

const getConversionRates = async () => {
  if (storage) {
    const cached = storage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const { rates, ts } = JSON.parse(cached);
        if (Date.now() - ts < CACHE_TTL_MS) return rates;
      } catch {
        // ignore corrupt cache entry
      }
    }
  }

  try {
    const response = await axios.get(
      'https://api.coingecko.com/api/v3/simple/price?ids=ethereum,matic-network,usd-coin&vs_currencies=usd'
    );
    const rates = response.data;
    if (storage) {
      storage.setItem(CACHE_KEY, JSON.stringify({ rates, ts: Date.now() }));
    }
    return rates;
  } catch (error) {
    console.error('Error fetching conversion rates:', error);
    return {};
  }
};

export default getConversionRates;
